const preloadImage = function(url) {
    const placeholder = document.createElement('img')
    placeholder.src = url
    return url
}

const scaffoldMenuData = function(primaryMenuDOM) {
    const menuData = {}

    primaryMenuDOM.forEach(menuDom => {
        menuDom.querySelectorAll('A').forEach(element => {
            const name = element.dataset.toplevel
            const href = element.href
            const displayName = element.innerText

            menuData[name] = {
                href,
                displayName,
                megaMenu: []
            }
        })
    })

    return menuData
}

const scrapeMegaMenuData = function(menuData, menu, column, index) {
    const arrowLinkClass = 'nlx-js--mega-menu-arrow-link'
    menuData[menu].megaMenu[index] = []
    column.querySelectorAll('A').forEach(link => {
        menuData[menu].megaMenu[index].push({
            arrowLink: link.classList.contains(arrowLinkClass),
            href: link.href,
            displayName: link.innerText
        })
    })
}

const parseSpotsAsJson = function(DOM) {
    const spotData = []
    const spotEl = '.nlx-js--mega-menu-spot'
    const spotDOM = DOM.querySelectorAll(spotEl)

    const titleEl = '.nlx-js--mega-menu-spot--title'
    const linkEl = '.nlx-js--mega-menu-spot--link'
    const imgEl = '.nlx-js--mega-menu-spot--img'

    spotDOM.forEach(spot => {
        spotData.push({
            title: spot.querySelector(titleEl).innerText,

            img: {
                src: preloadImage(spot.querySelector(imgEl).src),
                alt: spot.querySelector(imgEl).alt
            },
            link: {
                href: spot.querySelector(linkEl).href,
                displayName: spot.querySelector(linkEl).innerText
            }
        })
    })

    return spotData
}

const parseMenuAsJson = function(DOM) {

    const primaryMenuEl = '.nlx-js--primary-menu'
    const megaMenuEl = '.nlx-js--mega-menu'

    const primaryMenuDOM = DOM.querySelectorAll(primaryMenuEl)
    const megaMenuDOM = DOM.querySelector(megaMenuEl)

    if (!primaryMenuDOM.length || !megaMenuDOM) {
        throw new Error("No primary menu present")
    }

    const menuData = scaffoldMenuData(primaryMenuDOM)

    for (let menu in menuData) {
        const menuList = megaMenuDOM.querySelector(`[data-menu='${menu}']`)

        if (menuList) {
            const childArray = Array.from(menuList.children)
            childArray.forEach(scrapeMegaMenuData.bind(this, menuData, menu))
        }
    }

    menuData.spots = parseSpotsAsJson(DOM)

    megaMenuDOM.remove()

    return menuData

}



export default parseMenuAsJson